import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
// import { addUserValidation } from "../../utils/validation";
// import { isYupError, parseYupError } from "../../utils/Yup";
import { Country } from "country-state-city";
import Loader from "../../components/loaders/Loader";
import { reactIcons } from "../../utils/icons";
import { useNavigate } from "react-router-dom";
import UploadDocument from "../../components/UploadDocument";
import { ImageUploadInstructionDoc } from "../../utils/constants";
import EntityFormRef from "../../components/Forms/EntityFormRef";

const initialState = {
  type: "",
  name: "",
  RegistrationNumber: "",
  email: "",
  mobile: "",
  website: "",
  address_line_1: "",
  dateOfIncorporation: null,
  refineryMethodUsed: "",
  efficiencyMetrics: "",
  certification1: "",
  certification2: "",
  ol: [],
  ecl: [],
  refinerySustainabilityPractices: ""
};

const AddRefineries = () => {
  const [step1, setStep1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState({});
  const [dialCode, setDialCode] = useState("91");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [countryName, setCountryName] = useState("India");
  const [trackScapeImage, setTrackScapeImage] = useState([]);
  const [environmental, setEnvironmental] = useState([]);
  const [cardImage, setCardImage] = useState("");
  const [cardImage1, setCardImage1] = useState("");
  const [step1Completed, setStep1Completed] = useState(false);

  const navigate = useNavigate();
  console.log(cardImage, "cardImage");

  const handleFileChangee = async (e, keyName) => {
    if (e.target.files[0]?.size > 5242880) {
      toast.error("File size should not exceed 5MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    try {
      const response = await api.getFileUrl(formData);

      if (response.status) {
        if (keyName === "certification1") {
          setCardImage(response.data.url);
          setForm({
            ...form,
            certification1: response.data.url
          });
        } else if (keyName === "certification2") {
          setCardImage1(response.data.url);
          setForm({
            ...form,
            certification2: response.data.url
          });
        }
      } else {
        toast.error(response.error.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleRemoveDoc = (dIndex, type, key) => {
    setForm((prev) => {
      const updatedList =
        prev?.[type]?.filter((_, index) => index !== dIndex) || [];
      return {
        ...prev,
        [type]: updatedList.length > 0 ? updatedList : []
      };
    });

    if (key === "ol") {
      setTrackScapeImage((prevArray) => {
        const updatedImages = prevArray.filter((_, index) => index !== dIndex);
        return updatedImages.length > 0 ? updatedImages : [];
      });
    } else if (key === "ecl") {
      setEnvironmental((prevArray) => {
        const updatedImages = prevArray.filter((_, index) => index !== dIndex);
        return updatedImages.length > 0 ? updatedImages : [];
      });
    }
  };

  const handleStepComplete = (stepData) => {
    setForm({
      ...form,
      ...stepData
    });
    setStep1Completed(true);
    setStep1(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    // Validate step 2 fields
    if (!form.refineryMethodUsed) {
      toast.error("Annual production capacity is required");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        type: form.type,
        primaryContactName: form.primaryContactName,
        name: form.name,
        registrationNumber: form.RegistrationNumber,
        emailAddress: form.email,
        phoneNumber: `+${dialCode}${form.mobile}`,
        website: form.website || "",
        address_line_1: form.address_line_1,
        dateOfIncorporation: form.dateOfIncorporation,
        dialCode: "+" + dialCode,
        country: countryName,
        countryOfIncorporation: selectedCountry,
        refineryMethodUsed: form.refineryMethodUsed,
        efficiencyMetrics: form.efficiencyMetrics || "",
        certification1: cardImage || "",
        certification2: cardImage1 || "",

        addedBy: "admin",
        organizationRole: [
          {
            refineryMethodUsed: [form?.refineryMethodUsed],
            refinerySustainabilityPractices: [
              form?.refinerySustainabilityPractices
            ],
            refineryCertification: [
              cardImage?.split("/").pop(),
              cardImage1?.split("/").pop()
            ],
            refineryIsoCertification: form.ol || [],
            refineryOperationalLicense: form.ecl || []
          }
        ]
      };

      const res = await api.registerUser(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Refineries Added Successfully");
        navigate(-1);
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while submitting the form");
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    const country = Country.getAllCountries().find(
      (c) => c.isoCode === countryCode
    );
    setCountryName(country.name);
    setDialCode(country?.phonecode);
  };

  const handleFileChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size should not exceed 5MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await api.getFileUrl(formData);

      if (response?.status) {
        const fileName = response?.data?.meta?.filename || "";
        const fileUrl = response?.data?.url || "";

        setForm((prev) => ({
          ...prev,
          [type]: [...(prev?.[type] || []), fileName]
        }));

        if (type === "ol") {
          setTrackScapeImage((prevArray) => [...prevArray, fileUrl]);
        } else if (type === "ecl") {
          setEnvironmental((prevArray) => [...prevArray, fileUrl]);
        }
      } else {
        toast.error(response?.error?.message || "File upload failed");
      }
    } catch (err) {
      toast.error(err?.message || "An error occurred while uploading the file");
    }
  };

  useEffect(() => {
    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);

  return (
    <div>
      <header className="flex gap-2">
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 flex-center bg-custom-gradient rounded-full text-3xl"
        >
          {reactIcons.arrowleft}
        </button>{" "}
        <h4 className="text-white">Add Refineries</h4>
      </header>
      <div className="border mt-5 border-yellow-dark p-5 rounded-[10px]">
        <form onSubmit={handleSubmit}>
          <div className="relative">
            {!step1 ? (
              <div className="font-semibold text-white text-20">Step 1</div>
            ) : (
              <div className="font-semibold text-20 text-white">Step 2</div>
            )}
            {!step1 ? (
              <EntityFormRef
                handleChange={handleChange}
                formError={formError}
                handleCountryChange={handleCountryChange}
                selectedCountry={selectedCountry}
                Country={Country}
                dialCode={dialCode}
                onStepComplete={handleStepComplete}
              />
            ) : (
              <div className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 items-center mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">
                    Refining method(s){" "}
                  </label>
                  <input
                    type="text"
                    placeholder="Enter capacity"
                    autoComplete="off"
                    name="refineryMethodUsed"
                    onChange={handleChange}
                    className="text-input text-black text-12 lg:text-14 border"
                    required
                  />
                  {formError.refineryMethodUsed && (
                    <div className="form-eror">
                      {formError.refineryMethodUsed}
                    </div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-white">
                    Sustainability practices (if applicable)
                  </label>
                  <input
                    type="text"
                    placeholder="Enter efficiency metrics"
                    autoComplete="off"
                    name="refinerySustainabilityPractices"
                    onChange={handleChange}
                    className="text-input text-black text-12 lg:text-14 border"
                  />
                </div>

                <div className="input-group">
                  <label className="relative block text-white mb-3 font-medium text-black text-14">
                    Certification 1
                  </label>
                  <div className="relative max-w-[300px] mb-3">
                    <div className="w-full h-24 border border-primary-100 rounded-xl overflow-hidden p-[10px]">
                      <img
                        className={`w-full ${
                          cardImage ? "" : "opacity-40"
                        }  h-full object-contain`}
                        src={cardImage ? cardImage : "/images/no-img.jpg"}
                        alt="user"
                      />
                      <input
                        type="file"
                        onChange={(e) => handleFileChangee(e, "certification1")}
                        name="file1"
                        id="file1"
                        hidden
                      />
                    </div>
                    <label
                      htmlFor="file1"
                      className="w-10 h-10 flex items-center justify-center text-18 absolute cursor-pointer -right-2 -bottom-1 rounded-full bg-[#f2f2f2] shadow-lg text-primary-100"
                    >
                      {reactIcons.upload}
                    </label>
                  </div>
                </div>

                <div className="input-group">
                  <label className="relative block text-white mb-3 font-medium text-black text-14">
                    Certification 2
                  </label>
                  <div className="relative max-w-[300px] mb-3">
                    <div className="w-full h-24 border border-primary-100 rounded-xl overflow-hidden p-[10px]">
                      <img
                        className={`w-full ${
                          cardImage1 ? "" : "opacity-40"
                        }  h-full object-contain`}
                        src={cardImage1 ? cardImage1 : "/images/no-img.jpg"}
                        alt="user"
                      />
                      <input
                        type="file"
                        onChange={(e) => handleFileChangee(e, "certification2")}
                        name="file2"
                        id="file2"
                        hidden
                      />
                    </div>
                    <label
                      htmlFor="file2"
                      className="w-10 h-10 flex items-center justify-center text-18 absolute cursor-pointer -right-2 -bottom-1 rounded-full bg-[#f2f2f2] shadow-lg text-primary-100"
                    >
                      {reactIcons.upload}
                    </label>
                  </div>
                </div>
                <div className="input-group">
                  <UploadDocument
                    upload={true}
                    instrunctionList={ImageUploadInstructionDoc}
                    heading="ISO Certification"
                    handleFileChange={(e) => handleFileChange(e, "ol")}
                    name="refineryIsoCertification"
                    id="rId_ol"
                    value={trackScapeImage}
                    setForm={setForm}
                    handleRemoveDoc={handleRemoveDoc}
                    type="ol"
                  />
                </div>
                <div className="input-group">
                  <UploadDocument
                    upload={true}
                    instrunctionList={ImageUploadInstructionDoc}
                    heading="Operational License"
                    handleFileChange={(e) => handleFileChange(e, "ecl")}
                    name="refineryOperationalLicense"
                    id="rId_ecl"
                    value={environmental}
                    setForm={setForm}
                    handleRemoveDoc={handleRemoveDoc}
                    type="ecl"
                  />
                </div>
              </div>
            )}
          </div>
          {!step1 ? (
            <div className="flex gap-2 mt-5 justify-end items-center">
              {/* Step 2 button is now inside the EntityForm component */}
            </div>
          ) : (
            <div className="flex gap-2 mt-5 justify-end items-center">
              <button
                type="button"
                onClick={() => setStep1(false)}
                className={`btn btn-danger `}
              >
                {reactIcons.arrowleft} Back
              </button>
              <button
                type="submit"
                disabled={isLoading || !form.refineryMethodUsed}
                className={`btn btn-primary ${
                  isLoading || !form.refineryMethodUsed
                    ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                    : undefined
                }`}
              >
                {isLoading ? <Loader /> : "Submit"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddRefineries;
